import { isPlatformBrowser } from "@angular/common";
import { MLLog } from "../logger/Logger";


export enum DeviceKind {
    LITTLE,
    MEDIUM,
    WIDE,
    WIDER,
    ULTRA
}

const DEVICE_KIND_LITTLE_MAX_WIDTH = 656;
const DEVICE_KIND_MEDIUM_MAX_WIDTH = 992;
const DEVICE_KIND_WIDE_MAX_WIDTH = 1200;
const DEVICE_KIND_WIDER_MAX_WIDTH = 1920;


export function htmldoc() {
    return PlatformReference.getDocument();
}

export class PlatformReference {

    private static platformId: Object | null = null;

    private static serverSideDocument: any | null = null;

    public static setup(platformId: Object) {
        this.platformId = platformId;
    }

    public static isBrowser() {
        //MLLog.logDev("Is Platfomr reference setup?", PlatformReference.platformId)
        if (PlatformReference.platformId) {
            return isPlatformBrowser(PlatformReference.platformId);//this.browser;
        }
        return false;
    }

    public static getDeviceKind(): DeviceKind {
        //MLLog.logDev("PlatformReference.isBrowser()", PlatformReference.isBrowser())
        if (PlatformReference.isBrowser()) {
            const width = window.innerWidth;
            //MLLog.logDev("width", width)
            if (width < DEVICE_KIND_LITTLE_MAX_WIDTH) {
                return DeviceKind.LITTLE;
            }
            if (width < DEVICE_KIND_MEDIUM_MAX_WIDTH) {
                return DeviceKind.MEDIUM;
            }
            if (width < DEVICE_KIND_WIDE_MAX_WIDTH) {
                return DeviceKind.WIDE;
            }
            if (width < DEVICE_KIND_WIDER_MAX_WIDTH) {
                return DeviceKind.WIDER;
            }
        }
        return DeviceKind.ULTRA;
    }

    public static getDocument() {
        if (this.platformId) {
            if (this.isBrowser()) {
                return document;
            } else {
                return this.buildServerSideDocument();
            }
        } else {
            MLLog.logError("Platform is not setup in PlatformReference")
        }
    }

    private static buildServerSideDocument() {
        if (this.serverSideDocument == null) {
            this.serverSideDocument = {
                documentElement: {
                    clientWidth: 800,
                    clientHeight: 600
                }
            }
        }
        return this.serverSideDocument;
    }
}